import { lazyPipe, validateApiResponse, withApiErrorCapture } from '@musinsa/apis-common-api-zod4';
import { executeStandardRequest } from '@musinsa/packages-http';
import urlJoin from 'url-join';
import z from 'zod';
import { privateHttpClient } from '../httpClient';
import { createApiResponseSchema } from '../utils';
import { campaignsApiPath } from './apiPath';

/** 수락 응답 — swagger AcceptSeedingProposalResponse */
const AcceptSeedingProposalResponseDataSchema = z.object({
  orderNo: z.string(),
  orderOptionIds: z.array(z.number()),
  fulfillmentIds: z.array(z.number()),
});

const AcceptSeedingProposalResponseSchema = createApiResponseSchema(
  AcceptSeedingProposalResponseDataSchema,
);

export type AcceptSeedingProposalResponse = z.infer<typeof AcceptSeedingProposalResponseSchema>;

// NOTE: 204 No Content (성공) — 응답 본문이 비어 있다. 표준 래퍼({ meta, data })가 아니라
// 빈 문자열('')이 내려오므로 createApiResponseSchema(z.null()) 로 검증하면 실패→throw 하던 문제.
// (거절 성공인데 "거절 실패" 토스트가 뜨던 원인 — 상세 reject API 와 동일하게 unknown 통과) (SID-4053)
const RejectSeedingProposalResponseSchema = z.unknown().describe('RejectSeedingProposalResponse');

export type RejectSeedingProposalResponse = z.infer<typeof RejectSeedingProposalResponseSchema>;

export interface PostSeedingProposalRejectRequest {
  participationId: number;
  rejectionReasonCodes: string[];
}

export const postSeedingProposalAccept = withApiErrorCapture(
  lazyPipe(
    async (participationId: number): Promise<AcceptSeedingProposalResponse> =>
      executeStandardRequest(async () => {
        const response = await privateHttpClient.post<AcceptSeedingProposalResponse>(
          urlJoin(campaignsApiPath.postSeedingProposalAccept(participationId)),
        );
        return response;
      }),
    validateApiResponse(AcceptSeedingProposalResponseSchema),
  ),
);

export const postSeedingProposalReject = withApiErrorCapture(
  lazyPipe(
    async ({
      participationId,
      rejectionReasonCodes,
    }: PostSeedingProposalRejectRequest): Promise<RejectSeedingProposalResponse> =>
      executeStandardRequest(async () => {
        const response = await privateHttpClient.post<RejectSeedingProposalResponse>(
          urlJoin(campaignsApiPath.postSeedingProposalReject(participationId)),
          { rejectionReasonCodes },
          // 204 No Content 의 빈 본문을 JSON 파싱하다 throw 하지 않도록 text 로 받는다. (SID-4053)
          { responseType: 'text' },
        );
        return response;
      }),
    validateApiResponse(RejectSeedingProposalResponseSchema),
  ),
);
